import { StorageConfigInterface, StorageDataType, StorageInterface, StorageType } from '../types/storageTypes';

class CookieStorage implements StorageInterface {
  private _options: StorageConfigInterface[StorageType.COOKIE];
  constructor(configurations: StorageConfigInterface[StorageType.COOKIE]) {
    this._options = configurations;
  }

  store(key: string, value: string | StorageDataType) {
    document.cookie = `${key}=${value}`;
  }

  retrieve(key: string): string {
    const cookies = document.cookie;
    if (key && cookies.includes(`${key}=`)) {
      return cookies.split(`${key}=`)[1]?.split(';')[0];
    }
    return '';
  }

  remove(key: string): void {
    const cookies = document.cookie;
    if (key && cookies.includes(`${key}=`)) {
      document.cookie = `${key}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    }
  }

  clearStorage() {
    // do nothing
  }
}

export default CookieStorage;
